import React, { useEffect, useState, useCallback } from 'react';
import { Divider, Grid, makeStyles, Typography } from "@material-ui/core";
import { Edit3, FileText, CornerDownLeft } from "react-feather"
import { SECONDARY_COLOR, LIGHT_GRAY_COLOR } from '../../../theme';
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import LinkButton from "../../../shared/components/LinkButton";
import Botao from "../../../shared/components/Botao";
import { CODIGO_TECLA_S } from "../../../shared/utils/Constantes";
import ModalLoteFinalizadoSucesso from '../../../shared/components/ModalLoteFinalizadoSucesso'
import { formatarCodigoLote, formatarTemperatura } from '../../../shared/utils/Formatacao';
import ModalImpressao from '../../modalImpressaoEtiquetas/views/ModalImpressao';

const DadosLateralDireita = ({
    dadosLote,
    selecionandoAmostras,
    quantidadeAmostrasLote,
    handleAlterarExibicaoAmostras,
    handleClickEditarDados,
    carregando,
    editando,
    codigoLaboratorio,
    usaApplet,
    portaGti
}) => {
    const classes = useStyles();
    const history = useHistory();
    const [modalAberto, setModalAberto] = useState(false);
    const [modalImpressaoAberto, setModalImpressaoAberto] = useState(false);
    const [modalFoiAberto, setModalFoiAberto] = useState(false);

    const handleSalvarClick = useCallback(() => {
        setModalAberto(true);
    }, [])

    const handleChangeImprimir = () => {
        setModalImpressaoAberto(true);
    };

    useEffect(() => {
        const submitShortcut = (event) => {
            if (event.ctrlKey && event.which === CODIGO_TECLA_S) {
                event.preventDefault();
                handleSalvarClick();
            }
        }

        document.addEventListener('keydown', submitShortcut);

        return () => document.removeEventListener('keydown', submitShortcut);
    }, [handleSalvarClick]);

    useEffect(() => {
        if (modalAberto === true) {
            setModalFoiAberto(true);
        }
        if (modalAberto === false && modalFoiAberto === true) {
            history.push({
                pathname: "/lotes",
            });
        }
    }, [modalAberto, modalFoiAberto, history]);

    return (
        <>
            <ModalImpressao
                codigoLaboratorio={codigoLaboratorio}
                idLote={dadosLote.id}
                usaApplet={usaApplet}
                portaGti={portaGti}
                modalAberto={modalImpressaoAberto}
                setModalAberto={setModalImpressaoAberto}
            />
            <ModalLoteFinalizadoSucesso
                dadosLote={dadosLote}
                quantidadeAmostrasLote={quantidadeAmostrasLote}
                editando={editando}
                setModalAberto={setModalAberto}
                modalAberto={modalAberto}
                handleChangeImprimir={handleChangeImprimir}
            />

            <Grid container spacing={1}>
                <Grid item className={classes.dadosLote}>
                    <Typography variant="h4" className={classes.subtitulo}>
                        Dados do lote
                    </Typography>
                    <Typography variant="body1">
                        Número da etiqueta: {formatarCodigoLote(dadosLote.codigo)}
                    </Typography>
                    <Typography variant="body1">
                        Tipo do lote: {dadosLote.tipoLote?.descricao}
                    </Typography>
                    <Typography variant="body1">
                        Conservação: {dadosLote.tipoConservacao?.descricao}
                    </Typography>
                    <Typography variant="body1">
                        Temperatura do lote: {formatarTemperatura(dadosLote.temperatura)}
                    </Typography>
                    <LinkButton
                        label="Editar dados"
                        icone={
                            <Edit3 size={17} color={quantidadeAmostrasLote > 0 || carregando ? LIGHT_GRAY_COLOR : SECONDARY_COLOR} />
                        }
                        onClick={handleClickEditarDados}
                        desabilitado={quantidadeAmostrasLote > 0 || carregando}
                        className={classes.botaoDadosLote}
                        fontSize={16}
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={12} className={classes.divider}>
                    <Divider />
                </Grid>
                <Grid item>
                    <Typography variant="h4" className={classes.subtitulo}>
                        {quantidadeAmostrasLote} amostra(s) no lote
                </Typography>
                    <LinkButton
                        label={selecionandoAmostras ? "Ver amostras no lote" : "Selecionar manualmente"}
                        icone={
                            selecionandoAmostras
                                ? <FileText color={carregando ? LIGHT_GRAY_COLOR : SECONDARY_COLOR} />
                                : <CornerDownLeft color={carregando ? LIGHT_GRAY_COLOR : SECONDARY_COLOR} />
                        }
                        onClick={handleAlterarExibicaoAmostras}
                        desabilitado={carregando}
                        className={classes.botaoDadosLote}
                        fontSize={16}
                    />
                </Grid>
                <Grid item>
                    <Botao
                        id="salvarEIrParaListagem"
                        type="primary"
                        className={classes.botao}
                        titulo={editando ? "Concluir alterações" : "Concluir e gerenciar lotes"}
                        atalho="(CTRL + S)"
                        onClick={() => {
                            handleSalvarClick()
                        }}
                        disabled={carregando}
                    />
                </Grid>
            </Grid>
        </>
    );
}

const useStyles = makeStyles((theme) => ({
    subtitulo: {
        marginBottom: theme.spacing(2),
    },
    botaoDadosLote: {
        marginTop: theme.spacing(1),
    },
    dadosLote: {
        marginBottom: theme.spacing(8),
    },
    botao: {
        position: "absolute",
        bottom: "0px",
        right: "0px",
        width: "300px",
        height: "56px",
        margin: "15px"
    },
    divider: {
        marginBottom: theme.spacing(1.8),
        paddingRight: "0px",
    },
}))

const mapStateToProps = state => {
    return {
        codigoLaboratorio: state.login.laboratorio.codigo,
        usaApplet: state.login.laboratorio.usaApplet,
        portaGti: state.login.laboratorio.portaGti
    };
};

export default connect(
    mapStateToProps
)(DadosLateralDireita);